import { ShootingEyeType } from 'src/models/Eye.model';

export interface AutoStateResponse {
  state: StatusOfShootingEnum;
  filename: string[];
  isPupilSmall: boolean;
  take: ShootingEyeType;
}

export enum StatusOfShootingEnum {
  COMPLETE = 'COMPLETE',
  COMPLETE_LEFT = 'COMPLETE_LEFT',
  COMPLETE_RIGHT = 'COMPLETE_RIGHT',
  RUNNING = 'RUNNING',
  ERROR = 'ERROR',
  IDLE = 'IDLE',
}

export enum CaptureModeEnum {
  BOTH_EYE = 'both_eye',
  LEFT_EYE = 'left_eye',
  RIGHT_EYE = 'right_eye',
}

export type AutoTakePhotoRequest = {
  eyetype?: CaptureModeEnum;
  OS?: number;
  OD?: number;
  filename?: string;
  _id?: string;
};

export type ShootingResponse = {
  error_code: number;
  msg: string;
};

export interface GetDeviceSNResponse extends ShootingResponse {
  data: string;
}
